import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZakazkaDruh = {
	name: NAME,
	apiProvider,
	router,
};
